export default __webpack_public_path__ + "static/media/training-illustration8.d2e87e65.png";